<template>
	<div class="card">
			<template v-if="series.length > 0">
				<VueApexCharts
					type="area"
					:options="options"
					:series="series"
					height="190"
				/>
			</template>
  	</div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
  	data() {
		return {
      		options: {
				theme: {
          			mode: "light"
				},
        		colors: ["#222222"],
        		stroke: {
          			curve: "smooth"
        		},
				title: {
					text: undefined,
          			align: "center",
          			margin: 10,
          			offsetX: 0,
          			offsetY: 0,
          			floating: false,
          			style: {
            			fontSize: "14px",
            			fontWeight: "bold",
            			fontFamily: undefined,
            			color: "#263238"
          			}
        		},
        		noData: {
          			text: "Carregando...",
          			align: "center",
          			verticalAlign: "middle",
          			offsetX: 0,
					offsetY: 0,
          			style: {
            			color: undefined,
						fontSize: "16px",
            			fontFamily: undefined
          			}
				},
				yaxis: {
          			labels: {
            		formatter: function(val) {
              			return val.toFixed(0);
					}
				}
        		},
				responsive: [
          			{
            			breakpoint: 700,
            			options: {
              				chart: {
                				sparkline: {
                  					enabled: false
                				}
              				}
            			}
          			}
        		],
				chart: {
					height: "190px",
					id: 'Gráfico de acessos ao site.',
					toolbar: {
						show: false
					},
					zoom: {
						enabled: false
					},
				},
				dataLabels: {
					enabled: false
				},
				tooltip: {
              	x: {
                	format: 'dd/MM'
              	},
            },
			},
			series: []
		};
	},
  	props: {
    	chartData: {
      		type: Object,
      		required: false
		},
    	color: {
      		type: String,
      		required: false,
      		default: "#222222"
    	}
  	},
  	watch: {
    	chartData() {
			this.updateChart(this.chartData);
    	},
		color() {
			this.updateTheme(this.color);
    	}
  	},
  	components: {
		  VueApexCharts
	},
	mounted(){
		this.updateTheme(this.color);
		setTimeout(() => {
			this.updateChart(this.chartData);
		}, 300);
	}  ,
  	methods: {
    	updateChart(chartData) {
			const newDataSeries = [{...chartData.series}];
			const newDataXaxis = [...chartData.xaxis];
      		this.series = [...newDataSeries];
			this.options.xaxis = {
				type: "category",
				categories: newDataXaxis,
				labels: {
						show: true,
						rotate: -10},
				hideOverlappingLabels: true,
			}
			// console.log(this.options.xaxis)
    	},
		updateTheme(colors) {
			this.options.colors.splice(0,1,colors);
    	}
  	}
};
</script>

<style scoped>
	.card {
	border-radius: 12px ;
	padding-left: 15px;
	padding-right: 15px;
	}

</style>


// WEBPACK FOOTER //
// src/components/molecules/ReportChart.vue